var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"billing-cat",style:(_vm.imgStyle),attrs:{"src":_vm.src,"alt":"","aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }